// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Bq9Pj","buttons":"Footer_buttons__33eV2"};